import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { CommonLayoutModule } from '@sdbn/common';
import { ShowMessageComponent } from './component/show-message.component';
import { CenteredScrollableContentModule } from '../centered-scrollable-content/centered-scrollable-content.module';



@NgModule({
  declarations: [
    ShowMessageComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    ApplicationClientCommonModule,
    CenteredScrollableContentModule,
    CommonLayoutModule,
    CommonTranslationModule,

  ]
})
export class ShowMessageModule { }
